import React from 'react';
import styled from 'styled-components';
import { brandColours } from '../styles';
import Breadcrumbs from './Breadcrumbs';
import SpaGallery from './SpaGallery';
import SpaHeader from './SpaHeader';
import ContentAlert from './ContentAlert';
import ContentFeaturedPoints from './ContentFeaturedPoints';

const StyledSpaIntro = styled.div`
  padding-bottom: 20px;
  background-color: ${({ altTheme }) =>
    altTheme ? brandColours.denary : brandColours.senary};
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  position: relative;
  z-index: 2;
  background-color: ${({ altTheme }) =>
    altTheme ? brandColours.denary : brandColours.senary};
`;

const SpaIntro = ({
  heading,
  breadcrumbs,
  address,
  minPrice,
  higherPrice,
  isPricePerPerson,
  rating,
  images,
  isLuxury,
  isJenniferYoung,
  importantAdvice,
  content,
  popularFacilities,
  shareData,
  wishlistSpa,
  altTheme,
  hasPackages,
  giftVouchers,
  activateSpaVouchersFilter,
}) => (
  <StyledSpaIntro altTheme={altTheme}>
    <StyledBreadcrumbs items={breadcrumbs} altTheme={altTheme} />
    <SpaGallery images={images} isLuxury={isLuxury} />
    <SpaHeader
      heading={heading}
      address={address}
      minPrice={minPrice}
      higherPrice={higherPrice}
      isPricePerPerson={isPricePerPerson}
      isJenniferYoung={isJenniferYoung}
      rating={rating}
      shareData={shareData}
      wishlistSpa={wishlistSpa}
      altTheme={altTheme}
      hasPackages={hasPackages}
      giftVouchers={giftVouchers}
      activateSpaVouchersFilter={activateSpaVouchersFilter}
    />
    {importantAdvice && (
      <ContentAlert
        heading={importantAdvice.heading}
        subheading={importantAdvice.subHeading}
        text={importantAdvice.adviceHtml}
        enquiryButtonEnabled={importantAdvice.enquiryButtonEnabled}
      />
    )}
    <div id="spa-about">
      <ContentFeaturedPoints
        heading="About"
        content={content}
        featuredPointsHeading="Popular Facilities"
        featuredPoints={popularFacilities}
        areIconPoints={true}
        altTheme={altTheme}
      />
    </div>
  </StyledSpaIntro>
);

export default SpaIntro;
